(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hushedjoy-match"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hushedjoy-match')) {
  customElements.define('hushedjoy-match', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const results = this.querySelector('.hj-match__results');
      const cards = Array.from(this.querySelectorAll('.hj-match__card'));
      form.addEventListener('submit', event => {
        event.preventDefault();
        const values = new FormData(form);
        let count = 0;
        cards.forEach(card => {
          const matchesIntent = values.get('intent') === 'all' || card.dataset.tags.split(',').includes(values.get('intent'));
          const matchesBudget = Number(card.dataset.price) <= Number(values.get('budget'));
          const exclusion = values.get('exclude');
          const matchesExclusion = exclusion === 'none' || (exclusion === 'internal' && card.dataset.internal === 'false') || (exclusion === 'electronic' && card.dataset.electronic === 'false');
          const show = matchesIntent && matchesBudget && matchesExclusion && count < 3;
          card.hidden = !show;
          if (show) count++;
        });
        results.hidden = false;
        this.querySelector('.hj-match__empty').hidden = count > 0;
        this.querySelector('.hj-match__status').textContent = this.querySelector('[data-count-label]').textContent.replace('[count]', String(count));
        results.querySelector('h2').focus();
      });
      form.addEventListener('reset', () => { results.hidden = true; cards.forEach(card => {card.hidden = true;}); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
